"use client";

import { c as _c } from "react/compiler-runtime";
import { Toaster as SonnerToaster } from "@/components/ui/sonner";
import { useToast } from "@/lib/use-toast";
const Toaster = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SonnerToaster />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export { Toaster, useToast };